module.exports = __webpack_public_path__ + "static/media/PS-03.e773880e.svg";